import React, { useEffect, useState } from 'react'

import { HomeFilled } from '@ant-design/icons'
import { Button, Card, Form, Row, Typography, Icon, notification, Breadcrumb } from 'antd'
import { Formik } from 'formik'

import { ACAO_VALIDATION_SCHEMA } from './CategoryActionValidatiton'
import { RULES, validRule } from '../../constants/Entitlements'
import { getMessage } from '../../util/IntlMessages'
import CustomSwitch from '../../components/CustomSwitch/customSwitch'
import CustomInput from '../../components/CustomInput/customInput'
import { api, request } from '../../util/handlerRequestUtil'
import CustomSelect from '../../components/CustomSelect/customSelect'
import { Classifications } from '../../util/classifications'

const CreateCategoryAction = ({ match, history }) => {
  const [categorias, setCategorias] = useState([])
  const [categoryAction, setCategoryAction] = useState({})
  const { id } = match.params
  const params = history.location.state

  useEffect(() => {
    load()
  }, [id])

  async function load() {
    await fetchCategorias()

    if (params && params.categoryId) {
      setCategoryAction({ active: true, idCategoria: params.categoryId })
    } else {
      setCategoryAction({ active: true })
    }

    if (id) {
      await fetchCategoryActions(id)
    }
  }

  async function fetchCategorias() {
    const items = await request(api.getCategoriesSearch())
    const formattedItems = items.map(({ id, name }) => ({ value: id, description: name }))
    setCategorias(formattedItems)
  }

  async function fetchCategoryActions(id) {
    const [categoryAction] = await request(api.getAllEibCategoryActions({ id: id }))
    setCategoryAction({ ...categoryAction })
  }

  async function createCategoryAction(payload) {
    await request(api.createCategoryAction(payload))
    notification.success({
      description: getMessage('successStoreCategoryAction'),
      message: getMessage('sweetAlerts.success')
    })
  }

  async function updateCategoryAction(id, payload) {
    await request(api.updateCategoryAction(id, payload))
    notification.success({
      description: getMessage('successUpdateCategoryAction'),
      message: getMessage('sweetAlerts.success')
    })
  }

  async function onSubmit(values) {
    const payload = { ...values }
    if (!id) {
      await createCategoryAction(payload)
    } else {
      await updateCategoryAction(id, {
        active: payload.active,
        name: payload.name,
        classificacao: payload.classificacao,
        idCategoria: payload.idCategoria,
        codigoOrbia: payload.codigoOrbia
      })
    }

    history.goBack()
  }

  function renderHeader(submitForm) {
    const hasAccess = id ? validRule(RULES.ACAO) : validRule(RULES.ACAO)
    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb" style={{ marginBottom: '2px' }}>
          <Breadcrumb>
            <Breadcrumb.Item href="/">
              <HomeFilled style={{ fontSize: '16px' }} />
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/category/list">Categoria</Breadcrumb.Item>
          </Breadcrumb>
          <div className="default-header-buttons">
            <Button className="button-return" onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {hasAccess && (
              <Button type="primary" className="button-action" onClick={submitForm}>
                {id ? getMessage('update') : getMessage('register')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  function renderTitle() {
    return id ? getMessage('updateCategoryAction') : getMessage('categoryActionCreateButton')
  }

  return (
    <Formik
      enableReinitialize
      initialValues={categoryAction}
      validationSchema={ACAO_VALIDATION_SCHEMA}
      onSubmit={onSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ values, errors, submitForm, handleSubmit, handleBlur, setFieldValue }) => (
        <Form layout="vertical" onSubmit={handleSubmit}>
          {renderHeader(submitForm)}

          <Card className="ant-card gx-card ant-card-bordered">
            <Typography.Title className="default-header-title" level={3}>
              {renderTitle()}
              <Row type="flex" style={{ float: 'right' }}>
                <CustomSwitch
                  field="active"
                  errors={errors}
                  setFieldValue={setFieldValue}
                  rowSpan={12}
                  value={values}
                  handleBlur={handleBlur}
                  unCheckedChildren={getMessage('label.inactive')}
                  checkedChildren={getMessage('label.active')}
                />
              </Row>
            </Typography.Title>

            <Row type="flex" justify="start" align="bottom" style={{ marginTop: '20px' }}>
              <CustomInput
                labelInput="Nome da Ação"
                label="nome"
                field="name"
                errors={errors}
                placeholder="Digite aqui"
                setFieldValue={setFieldValue}
                rowSpan={9}
                value={values}
                handleBlur={handleBlur}
                required
              />
              <CustomSelect
                label="Categoria da Ação"
                showSearch
                field="idCategoria"
                setFieldValue={setFieldValue}
                rowSpan={5}
                value={values}
                values={categorias}
                required
              />
              <CustomSelect
                label={getMessage('categoryActionClassificationBayer')}
                showSearch
                field="classificacao"
                errors={errors}
                setFieldValue={setFieldValue}
                rowSpan={5}
                value={values}
                values={Classifications}
                sort={false}
                required
              />
              <CustomInput
                labelInput="Código Orbia"
                type="number"
                field="codigoOrbia"
                errors={errors}
                setFieldValue={setFieldValue}
                rowSpan={5}
                value={values}
              />
            </Row>
          </Card>
        </Form>
      )}
    </Formik>
  )
}

export default CreateCategoryAction
